import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { registerSW } from 'virtual:pwa-register';
import { initSentry } from './utils/sentry';

// Initialize Sentry as early as possible
initSentry();

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New content available. Reload?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
